import { render } from "./day-three-morning.vue?vue&type=template&id=76992120"
import script from "./day-three-morning.vue?vue&type=script&lang=js"
export * from "./day-three-morning.vue?vue&type=script&lang=js"
script.render = render

export default script